import { GridSingleSelectColDef } from '@mui/x-data-grid-pro';
import { format } from 'date-fns';
import { standardOperators } from '../../Compounds/UpstackDataGrid/helpers';

export const CommonRequestColumns: GridSingleSelectColDef[] = [
  {
    field: 'created_at',
    headerName: 'Requested date',
    width: 180,
    type: 'singleSelect',
    filterable: true,
    valueFormatter: (value) => (value ? format(new Date(value), 'MM/dd/yyyy h:mm a') : '')
  },
  {
    field: 'requested_by',
    headerName: 'Requested by',
    width: 180,
    filterable: true,
    type: 'singleSelect',
    filterOperators: standardOperators()
  },
  {
    field: 'request_type',
    headerName: 'Type of Request',
    width: 180,
    filterable: true,
    type: 'singleSelect',
    valueOptions: [],
    filterOperators: standardOperators()
  },
  {
    field: 'service_type',
    headerName: 'Type of Service',
    width: 200,
    filterable: true,
    type: 'singleSelect',
    valueOptions: [],
    filterOperators: standardOperators()
  },
  {
    field: 'locations',
    headerName: 'Location',
    width: 250,
    filterable: true,
    type: 'singleSelect',
    valueFormatter: (value, row) => {
      const locs: string[] = row.locations || [];
      const newLocs: string[] = (row.new_locations || []).map((loc: string | { address: string }) =>
        typeof loc === 'string' ? loc : loc.address
      );
      return [...locs, ...newLocs].join(', ');
    },
    valueGetter: (value, row) => {
      const locs: string[] = row.locations || [];
      const newLocs: string[] = (row.new_locations || []).map((loc: string | { address: string }) =>
        typeof loc === 'string' ? loc : loc.address
      );
      return [...locs, ...newLocs].join(', ');
    }
  },
  {
    field: 'preferred_term',
    headerName: 'Preferred Term',
    width: 150,
    filterable: true,
    type: 'singleSelect',
    valueOptions: [],
    filterOperators: standardOperators()
  }
];
